import type { Module } from 'vuex'
import type { StoreState } from '../store-state'

/**
 * 로그인한 병원.
 *
 * 서버가 주는 병원 문서를 그대로 담는다. 여기서 타입을 적은 건 예약시트가 실제로 읽는
 * 것뿐이고(_id, timezone), 나머지 필드는 화면마다 달라 index signature 로 열어 둔다.
 */
export type Hospital = {
    _id: string
    timezone?: string
    [extra: string]: unknown
}

export type HospitalState = {
    selectedHospital?: Hospital
    list: Hospital[]
}

const state: HospitalState = {
    selectedHospital: undefined,
    list: [],
}

type Store = { commit(type: string, payload: unknown): void }

const actions = {
    'AC_SetSelectedHospital': (store: Store, param: Hospital): void => {
        store.commit('MU_SelectedHospital', param)
    },
    'AC_SetHospitalList': (store: Store, param: Hospital[]): void => {
        store.commit('Mu_HospitalList', param)
    },
}

const mutations = {
    'MU_SelectedHospital': (state: HospitalState, param: Hospital): void => {
        state.selectedHospital = param
    },
    'Mu_HospitalList': (state: HospitalState, param: Hospital[]): void => {
        state.list = param
    },
}

const hospital: Module<HospitalState, StoreState> = { state, actions, mutations }

export default hospital
